import { useState, useCallback } from 'react';
import { resumeUpload } from '../../../supports/resumeUpload';
import { generateRequestId } from '../../../common/common';
import { transformApiResponse } from './utils';

const useDropdownData = () => {
    const [dropdownData, setDropdownData] = useState({
      sectors: { data: [], loading: false, loaded: false },
      subsectors: { data: [], loading: false, loaded: false },
      technicalDisciplines: { data: [], loading: false, loaded: false },
      activities: { data: [], loading: false, loaded: false },
      projectPhases: { data: [], loading: false, loaded: false },
      languages: { data: [], loading: false, loaded: false },
      nationalities: { data: [], loading: false, loaded: false },
      dualNationalities: { data: [], loading: false, loaded: false },
      languageLevels: { data: [], loading: false, loaded: false }
    });
    const fetchData = async (type, apiMethod, additionalParams = {}) => {
      setDropdownData(prev => ({ ...prev, [type]: { ...prev[type], loading: true } }));
      try {
        const requestBody = {
          user_payload: { request_id: generateRequestId() },
          ...additionalParams
        };
        const response = await apiMethod(requestBody);
        const transformedData = transformApiResponse(response.data || [], type);
        setDropdownData(prev => ({
          ...prev,
          [type]: { data: transformedData, loading: false, loaded: true }
        }));
      } catch (error) {
        if (error.name !== 'CanceledError' && error.name !== 'AbortError') {
          console.error(`Error fetching ${type}:`, error);
          setDropdownData(prev => ({
            ...prev,
            [type]: { data: [], loading: false, loaded: true }
          }));
        }
      }
    };
    const fetchSubsectors = async (sectorId) => {
      setDropdownData(prev => ({ ...prev, subsectors: { ...prev.subsectors, loading: true } }));
      await fetchData('subsectors', resumeUpload.getSubSectors, { sector_id: sectorId });
    };
    const fetchSectors = () => fetchData('sectors', resumeUpload.getSectors);
    const fetchTechnicalDisciplines = () => fetchData('technicalDisciplines', resumeUpload.getTechnicalDisciplines);
    const fetchActivities = () => fetchData('activities', resumeUpload.getActivities);
    const fetchProjectPhases = () => fetchData('projectPhases', resumeUpload.getProjectPhases);
    const fetchLanguages = () => fetchData('languages', resumeUpload.getLanguages);
    const fetchLanguageLevels = () => fetchData('languageLevels', resumeUpload.getLanguageLevels);
    const fetchNationalities = () => fetchData('nationalities', resumeUpload.getNationalities);
    const fetchDualNationalities = () => fetchData('dualNationalities', resumeUpload.getNationalities);
  
    return {
      ...dropdownData,
      fetchSectors,
      fetchSubsectors,
      fetchTechnicalDisciplines,
      fetchActivities,
      fetchProjectPhases,
      fetchLanguages,
      fetchNationalities,
      fetchDualNationalities,
      fetchLanguageLevels
    };
  };

export default useDropdownData;